import './index.scss'

$(".product-nav dt").click(function(){

    let $dl = $(this).parent();

    if($dl.hasClass("active")){

        $dl.removeClass("active");

    }else{

        $(".product-nav dl").removeClass("active");

        $dl.addClass("active");
    }

});